import {
  type CreateInclusionExclusionRequest,
  type UpdateInclusionExclusionRequest,
  type InclusionExclusionDetail,
  InclusionExclusionDetailSchema,
  type InclusionExclusionListQuery,
  type InclusionExclusionListResponse,
  InclusionExclusionListResponseSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Inclusions / exclusions master admin API. Every response is validated with
 * the shared Zod schema.
 */

const BASE = '/admin/inclusions-exclusions';

export const listInclusionsExclusions = async (
  query: InclusionExclusionListQuery,
): Promise<InclusionExclusionListResponse> => {
  const { data } = await apiClient.get<unknown>(BASE, { params: query });
  return InclusionExclusionListResponseSchema.parse(data);
};

export const getInclusionExclusion = async (id: string): Promise<InclusionExclusionDetail> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/${id}`);
  return InclusionExclusionDetailSchema.parse(data);
};

export const createInclusionExclusion = async (
  payload: CreateInclusionExclusionRequest,
): Promise<InclusionExclusionDetail> => {
  const { data } = await apiClient.post<unknown>(BASE, payload);
  return InclusionExclusionDetailSchema.parse(data);
};

export const updateInclusionExclusion = async (
  id: string,
  payload: UpdateInclusionExclusionRequest,
): Promise<InclusionExclusionDetail> => {
  const { data } = await apiClient.patch<unknown>(`${BASE}/${id}`, payload);
  return InclusionExclusionDetailSchema.parse(data);
};

export const deleteInclusionExclusion = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
